import { ProductAvailabilityPage } from './index'
import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard } from './../../shared/router/guards'
import BaseRouterGuard from './../../shared/router/BaseRouter.guard'
import UserProfileService from './../../shared/services/UserProfile.service'
import { BLOCKED_USERTYPES } from './ProductAvailability.constants'

// Same usertypes the Agent Resources nav link blocks (shared w/ First Sale Tracker).
class ProductAvailabilityAccessGuard extends BaseRouterGuard {
  authorize() {
    if (UserProfileService.isA(BLOCKED_USERTYPES)) return false
  }
}

export default [
  RouteFactory.create(
    ProductAvailabilityPage,
    '/product-availability',
    [new RequiresAuthGuard(true), new ProductAvailabilityAccessGuard()],
    {
      name: 'Product Availability by State',
    }
  ),
]
